<template>
  <app-page-title class='_ptxs _pbxs'>
    <template #pageTitleLeft>
      <h1 class='color-grape'>
        <font-awesome-icon v-if='memberLocked' :icon='memberIcon' class='_mrxs' aria-label="Locked"/>
        {{memberDetails.member.firstName}} {{memberDetails.member.lastName}}
      </h1>
    </template>
    <template #pageTitleRight>
      <a href="javascript:void(0)" @click="print" class="btn white --sm">Print</a>
      <div v-if="memberManagementAllowed">
        <tool-tip
          message="You may not add dependents to a voided subscriber."
          :top="true"
          :show-tool-tip="primarySubscriberVoided"
        >
          <router-link
            tag="button"
            :disabled="primarySubscriberVoided"
            v-if="!memberDetailsLoading && primarySubscriberCkToUseForDependents && !hideEdit"
            :to="{name: 'add-dependent', params: { primarySubscriberMemberCk: primarySubscriberCkToUseForDependents }}"
            class="_mls _mt0 btn --sm"

          >
            Add Dependent
          </router-link>
        </tool-tip>
        <router-link v-if='!memberLocked && !hideEdit' class='btn white --sm _mls' :to="{name: 'member-edit', params: { memberCk: memberCk }}">
          Edit
        </router-link>
      </div>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@organisms/PageTitle'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import memberManagement from '@mixins/memberManagement'
  import ToolTip from '@molecules/ToolTip'

  export default {
    mixins: [memberManagement],
    computed: {
      hideEdit() {
        return (
          !this.$store.getters.minimumAccess.memberMaintenanceAllowed
        )
      },
      memberCk() {
        return this.$store.getters['hiddenRouteData/getHiddenRouteData'].memberCk
      }
    },
    components: {
      ToolTip,
      AppPageTitle,
      FontAwesomeIcon
    },
    methods: {
      print () {
        window.print()
      }
    }
  }
</script>
